import { ApiSubUrls, Apis } from 'enums/api-constants'
import { fetchGeneralData } from 'queries/fetchData'

export const fetchBrands = fetchGeneralData<any>(
    `${ApiSubUrls[Apis.BRANDS]}/brands/`,
)
